var map = {
	"./EN": [
		"Edih",
		1
	],
	"./EN.js": [
		"Edih",
		1
	],
	"./FR": [
		"MrPz",
		0
	],
	"./FR.js": [
		"MrPz",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "gXRc";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/model/lang lazy ^\.\/.*$
// module id = gXRc
// module chunks = 3